/**
 * App environment (where the build is intended to run).
 *
 * CRA only exposes vars prefixed with `REACT_APP_` to the browser bundle, so the
 * process env key is `REACT_APP_DHIRAJ_ENV`. Application code uses `DHIRAJ_ENV`.
 *
 * - `pnpm start`  → development (see package.json)
 * - Firebase CI `pnpm build` → production
 *
 * This is separate from game *mode* (regular / sandbox / dev).
 */

export type AppEnv = 'development' | 'production';

/** Resolved once at module load (CRA injects the value at compile time). */
export const DHIRAJ_ENV: AppEnv =
  process.env.REACT_APP_DHIRAJ_ENV === 'production' ? 'production' : 'development';

export function isDevEnvironment(): boolean {
  return DHIRAJ_ENV === 'development';
}

export function isProdEnvironment(): boolean {
  return DHIRAJ_ENV === 'production';
}
